import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// hooks
import useObserver from "bodycodi/cmap/app/components/common/useObserver";

// components
import ProgramCard from "./ProgramCard";
import ProgramDetailPop from "./ProgramDetail";
import ShareAlert from "bodycodi/cmap/app/components/common/shareAlert";

// assets
import InfoIcon from "bodycodi/cmap/app/svg/icon_info_blue.svg";

// utils
import { api } from "bodycodi/cmap/app/js/api";
import { BODYDCODI_PLUS_URL } from "bodycodi/cmap/app/data/bodycodi-plus";

const ProgramManagement = ({ seqPlusSeller }: any) => {
  const { dispatch } = useContext(DispatchContext);
  const { seqPartner, seqPartnerBranch } = useSelector((state: RootState) => state.partner);
  const [currentTab, setCurrentTab] = useState<number>(0);
  const [refetch, setRefetch] = useState<number>(0);
  const [shareOpen, setShareOpen] = useState<boolean>(false);
  const [shareLink, setShareLink] = useState<string>("");
  const [list, setList] = useState<any>([]);
  const [tabCounts, setTabCounts] = useState<any>({ visible: 0, invisible: 0 });
  const [selectedProgram, setSelectedProgram] = useState<any>({});
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [scrollEnd, setScrollEnd] = useState<boolean>(false);
  const [_, setRef] = useObserver(async (entry: any, observer: any) => {
    observer.unobserve(entry.target);
    setScrollEnd(true);
    await fetchProgramList(false);
    observer.observe(entry.target);
  }, {});

  const fetchProgramList = async (reset: boolean) => {
    dispatch({ type: "LOADING_START" });
    await api
      .post("/plus/programs", {
        seqPlusSeller,
        seqPartner,
        seqPartnerBranch,
        displayYn: currentTab === 0 ? "Y" : "N",
        criteria: { page: reset ? 1 : page, pageSize },
      })
      .then(({ data }) => {
        if (data.first || reset) setList(data.results);
        else setList((prev: any) => [...prev, ...data.results]);

        setTabCounts({ visible: data.visible, invisible: data.invisible });

        if (data.results.length < pageSize) setScrollEnd(true);
        else setScrollEnd(false);
      })
      .finally(() => {
        if (reset) setPage(2);
        else setPage(page + 1);
        dispatch({ type: "LOADING_END" });
      });
  };

  useEffect(() => {
    setList([]);
    fetchProgramList(true);
  }, [currentTab, refetch]);

  const openDetail = (program: any) => {
    setSelectedProgram(program);
    dispatch({
      type: "POP_UP_OPEN",
      id: "PROGRAM_MANAGEMENT_DETAIL_POP",
      open: { programManagementDetailPop: true },
    });
  };

  const openShareAlert = async (program: any) => {
    try {
      setSelectedProgram(program);
      dispatch({ type: "LOADING_START" });
      await api
        .get(
          `/plus/programs/link?seqProgram=${program.seqPlusProgram}&seqPlusSeller=${seqPlusSeller}`
        )
        .then(({ data }) => {
          setShareLink(
            `${BODYDCODI_PLUS_URL}/program/${data?.seqPlusProgram}/${data?.seqPlusSeller}`
          );
          dispatch({ type: "LOADING_END" });
          setShareOpen(true);
        });
    } catch (error) {
      dispatch({ type: "LOADING_END" });
      console.error(error);
    }
  };

  return (
    <>
      <div className="popup-body no-padding">
        <div className="program-management">
          <div className="info">
            <img src={InfoIcon} />
            <span>
              판매 프로그램 전시를 중지하더라도 다른 셀러의 프로그램 판매에는 영향을 주지 않아요.
            </span>
          </div>

          <div className="tabs">
            <div className="tab" onClick={() => setCurrentTab(0)}>
              <div>
                전시중
                <span>{tabCounts?.visible}</span>
              </div>
              {currentTab === 0 && <hr />}
            </div>
            <div className="tab" onClick={() => setCurrentTab(1)}>
              <div>
                전시중지
                <span>{tabCounts?.invisible}</span>
              </div>
              {currentTab === 1 && <hr />}
            </div>
          </div>

          <div className="list">
            {list?.map((program: any) => {
              return (
                <ProgramCard
                  key={program?.seqPlusProgram}
                  type="list"
                  openDetail={() => openDetail(program)}
                  openShareAlert={() => openShareAlert(program)}
                  setRefetch={setRefetch}
                  {...program}
                />
              );
            })}
            {!scrollEnd && <div style={{ paddingBottom: 10 }} ref={setRef} />}
          </div>
        </div>
      </div>
      <ProgramDetailPop program={selectedProgram} setRefetch={setRefetch} />
      <ShareAlert
        open={shareOpen}
        setOpen={setShareOpen}
        header={"프로그램 공유"}
        description={`블로그나 인스타에\n프로그램을 공유해서 홍보해보세요.\n해당 링크로 바로 판매할 수 있어요!`}
        link={shareLink}
        program={selectedProgram}
        closeAlert={() => {
          setShareLink("");
          setSelectedProgram({});
        }}
      />
    </>
  );
};

export default ProgramManagement;
